export const environment = {
    env: process.env.REACT_APP_ENV,
    apiBaseURLClients: process.env.REACT_APP_API_BASE_URL_CLIENTS,
    disableAuth: process.env.REACT_APP_DISABLE_AUTH === 'true',
    systemId: process.env.REACT_APP_SYSTEM_ID || '',
}
